export const getFileName = (file: File) => file.name.slice(-15)
